import { render } from "./SettingsManagement.vue?vue&type=template&id=89c093c8&scoped=true"
import script from "./SettingsManagement.vue?vue&type=script&lang=js"
export * from "./SettingsManagement.vue?vue&type=script&lang=js"

import "./SettingsManagement.vue?vue&type=style&index=0&id=89c093c8&lang=css"
import "./SettingsManagement.vue?vue&type=style&index=1&id=89c093c8&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/HMS-MAIN/PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89c093c8"]])

export default __exports__